import React from "react";
import { Link } from "react-router-dom";

const Menus = () => {
  return (
    <ul>
      <li>
        <Link to="/">Home</Link>
      </li>
      <li>
        <Link to="/about">About us</Link>
      </li>      
      <li className="has-dropdown">
        <Link to="/service">Service</Link>
        <ul className="submenu">
          <li>
            <Link to="/corporate-vas">Corporate VAS</Link>
          </li>
          <li>
            <Link to="/mobile-vas">Mobile VAS</Link>
          </li>
          <li>
            <Link to="/production">Production</Link>
          </li>
        </ul>
      </li>  
      
      <li className="has-dropdown">
        <Link to="/blog">Media</Link>
        <ul className="submenu">
          <li>
            <Link to="/blog">News & Blog</Link>
          </li>
          <li>
            <Link to="/gallery">Gallery</Link>
          </li>
          <li>
            <Link to="/faq">Faq</Link>
          </li>
        </ul>
      </li>
      <li>
        <Link to="/contact">contact</Link>
      </li>
    </ul>
  );
};

export default Menus;
